module.exports = __webpack_public_path__ + "static/media/r-md10.fd383cb3.png";